import { Component } from '@angular/core';

@Component({
    selector: 'app-templates',
    imports: [],
    templateUrl: './templates.component.html',
    styleUrl: './templates.component.scss',
})
export class TemplatesComponent {}
